import { PtacSystemOptionType, PtacTerminalTwinType } from 'data/types';
import { formatUSD } from 'utils/helpers';

type PtacOptionCostFields = Pick<
  PtacSystemOptionType,
  'operatingCostBreakdown' | 'terminalTwin'
>;

type PtacOptionCostSource = Partial<PtacSystemOptionType> | null | undefined;

export const PTAC_TWIN_MIN_ANNUAL_SAVINGS = 10;

export function getPtacOperatingCostFields(
  system: PtacOptionCostSource
): PtacOptionCostFields {
  if (!system) return {};
  const { operatingCostBreakdown, terminalTwin } = system;
  return {
    ...(operatingCostBreakdown ? { operatingCostBreakdown } : {}),
    ...(terminalTwin ? { terminalTwin } : {})
  };
}

export function getPtacTerminalTwin(
  system: PtacOptionCostSource
): PtacTerminalTwinType | null {
  return getPtacOperatingCostFields(system).terminalTwin ?? null;
}

export function ptacTerminalTwinMessage(
  system: PtacOptionCostSource
): string | null {
  const twin = getPtacTerminalTwin(system);
  if (!twin) return null;
  const savings = Math.round(Math.abs(twin.annualCostDelta));
  if (savings < PTAC_TWIN_MIN_ANNUAL_SAVINGS) return null;
  if (twin.terminalType === 'pthp' && twin.annualCostDelta < 0) {
    return `Heat pump version saves about ${formatUSD(savings)}/yr`;
  }
  if (twin.terminalType === 'ptac' && twin.annualCostDelta > 0) {
    return `Saves about ${formatUSD(
      savings
    )}/yr over the electric-heat version`;
  }
  return null;
}
